import { take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SessionService } from '@app/session/session.service';
import { PopupWindowService } from '@app/services/popup-window.service';
import { EMailService } from '@app/origami-api/services/e-mail.service';
import { DocumentViewerUrlService } from '@app/services/document-viewer-url.service';
import { AccessRight } from '@app/origami-api/models/access-right';
import { ViewerType } from '@app/origami-api/constants/viewer-type';
import { OnlyOfficeConfig } from '@app/origami-api/utils/topic-utils';

@Injectable()
export class EmailAttachmentLinksGeneratorService {
  constructor(
    private sessionService: SessionService,
    private popupWindowService: PopupWindowService,
    private documentViewerUrlService: DocumentViewerUrlService,
    private emailService: EMailService,
  ) {}

  openDocumentInViewer(emailType: 'inbox' | 'outbox', topicId: number, fileId: number) {
    if (emailType === 'inbox') {
      const accessRight = AccessRight.AllRights;
      const paramsAddition = {
        ['s']: window.btoa('' + accessRight),
      };

      return this.documentViewerUrlService
        .getDocumentViewerInfo({
          siteId: this.sessionService.currentRoomId,
          fileInfo: { TopicId: topicId, FileId: fileId },
          paramsAddition: paramsAddition,
        })
        .pipe(take(1))
        .subscribe((info) => {
          let link;

          if (info.ViewerType === ViewerType.OnlyOfficeViewer) {
            let scfg = atob(info.ViewerData);

            if (scfg) {
              const cfg = <OnlyOfficeConfig>JSON.parse(scfg);

              cfg.mode = 'view';
            }

            link = link = `assets/pages/oo/index.html?${info.ViewerData}`;
          } else {
            link = info.ViewerUrl;
          }

          this.openLink(link);
        });
    }

    this.emailService
      .getMessageAttachment(this.sessionService.currentRoomId, topicId, fileId, true)
      .subscribe((res) => this.openLink(res.Result));
  }

  private openLink(link: string) {
    this.popupWindowService.openPopup({ url: link, name: 'Viewer_' + new Date().getTime() });
  }
}
